import "core-js/modules/es6.object.assign";
import * as encode from './encode';

function _encodeEntry(model, fixedShape) {
  var config = model.config;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, encode.baseEncodeEntry(model, {
    align: 'ignore',
    baseline: 'ignore',
    color: 'include',
    size: 'include',
    orient: 'ignore'
  })), encode.pointPosition('x', model, {
    defaultPos: 'mid'
  })), encode.pointPosition('y', model, {
    defaultPos: 'mid'
  })), encode.nonPosition('size', model)), encode.nonPosition('angle', model)), shapeMixins(model, config, fixedShape));
}

export function shapeMixins(model, config, fixedShape) {
  if (fixedShape) {
    return {
      shape: {
        value: fixedShape
      }
    };
  }

  return encode.nonPosition('shape', model);
}
export var point = {
  vgMark: 'symbol',
  encodeEntry: function encodeEntry(model) {
    return _encodeEntry(model);
  }
};
export var circle = {
  vgMark: 'symbol',
  encodeEntry: function encodeEntry(model) {
    return _encodeEntry(model, 'circle');
  }
};
export var square = {
  vgMark: 'symbol',
  encodeEntry: function encodeEntry(model) {
    return _encodeEntry(model, 'square');
  }
};